import React from 'react';

import { TrackingRefuelProvider } from './hooks/useTrackingRefuel';
import TrackingContainer from './TrackingContainer';

const TrackingRefuel: React.FC = () => {
  return (
    <TrackingRefuelProvider>
      <TrackingContainer />
    </TrackingRefuelProvider>
  );
};

export default TrackingRefuel;
